<template>
	<ux-panel>
		<ux-panel-title>
			<div class="text-caption">Details</div>
		</ux-panel-title>

		<ux-panel-body>
			<div class="row">
				<div class="col-md-6">
					<div class="ux-list">
						<order-detail-line title="Order date">{{ order.order_date | dateFormat('MMM Do, YYYY') }}</order-detail-line>

						<order-detail-line title="Processing Status">{{ order.processing_status | capitalize }}</order-detail-line>

						<order-detail-line title="Status Details">{{ order.status }}</order-detail-line>
					</div>
				</div>
				<div class="col-md-6">
					<div class="ux-list">
						<order-detail-line title="Is being picked up in store?">{{ order.pick_up_in_store ? 'Yes' : 'No' }}</order-detail-line>

						<order-detail-line title="Shipping address">{{ shippingAddr }}</order-detail-line>
						
						<order-detail-line title="Billing address">{{ billingAddr }}</order-detail-line>
					</div>
				</div>
			</div>
		</ux-panel-body>
	</ux-panel>
</template>

<script>
import { mapState } from 'vuex';

import filters from 'common/filters';

import OrderDetailLine from './OrderDetailLine.vue';

export default {
	components: { OrderDetailLine },
	mixins: [filters],

	computed: {
		...mapState({
			order: state => state.profile.currentOrder,
		}),

		shippingAddr()
		{
			var addr = `${this.order.shipping_street1}\n`;

			if (this.order.shipping_street2.trim())
				addr += `${this.order.shipping_street2.trim()}\n`;

			addr += `${this.order.shipping_city} ${this.order.shipping_region} ${this.order.shipping_postal_code}\n`;
			addr += this.order.shipping_country;

			return addr;
		},

		billingAddr()
		{
			var addr = `${this.order.billing_street1}\n`;

			if (this.order.billing_street2.trim())
				addr += `${this.order.billing_street2.trim()}\n`;

			addr += `${this.order.billing_city} ${this.order.billing_region} ${this.order.billing_postal_code}\n`;
			addr += this.order.billing_country;

			return addr;
		},

	},
}
</script>